/* eslint-disable import/first */
import React from 'react';
// import { useNavigate } from '@reach/router';
// eslint:fix
import DrawerPwa from '../../../components/DrawerPwa';
import DialogBox from '../../../components/DialogBox';
import SavedAddress from '../../../components/SavedAddress';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';

const SavedAddressDrawer = ({ isDesktop, isOpen, className, onClose }) => {
  // const navigate = useNavigate();
  // eslint:fix navigate is defined but never used

  return (
    <>
      {!isDesktop ? (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={isOpen}
          className={className}
          onClose={onClose}
        >
          <div className={css.addressDrawer}>
            <SavedAddress onSelect={onClose} action="select" showAction={false} />
          </div>
        </DrawerPwa>
      ) : (
        <DialogBox
          title={<FormattedMessage id="checkout_selectaddress" defaultMessage="Select Address" />}
          size="sm"
          isOpen={isOpen}
          onClose={onClose}
        >
          <div className={css.addressDrawer}>
            <SavedAddress onSelect={onClose} action="select" showAction={false} />
          </div>
        </DialogBox>
      )}
    </>
  );
};

export default SavedAddressDrawer;
